import { useEffect } from 'react';
import { navigate } from "@reach/router"

const AthletesHealthChecksPage = () => {
  useEffect(() => {
    navigate('/solutions/use-cases/daily-health-checks/');
  }, []);
  return null;
};

export default AthletesHealthChecksPage;